import React, { useState } from 'react'
import AppLayout from '../../../../layout/components/AppLayout'
import barcodeServices from '../barcodeServices'
import { useAlert } from '../../../../context/AlertContext'
import { useNavigate } from 'react-router-dom'

function BarcodeSearchPage() {
  const [searchInput,setSearchInput] = useState("")
  const {AppAlert} = useAlert();
  const navigate = useNavigate();
  const searchBarcode = () =>{
    barcodeServices.searchDocumentByBarcode(searchInput).then(res=>{
      if(res.data !== null ){
        navigate("/document/details/"+res.data.id)
      } else{
        AppAlert("Invalid Barcode or Not Yet Assigned","error");
      }
    }).catch(error=>{
      AppAlert(error.msg,"error")
    })
  }

  return (
    <AppLayout>
        <div className='container-fluid'>
            <div className='row'>
              <div className='col-md-6'>
                <div className="input-group mb-3">
                  <input 
                    type="text" className="form-control" placeholder="Scan barcode here"
                    onChange={(e)=>setSearchInput(e.target.value)} value={searchInput}
                    onKeyUp={ (e) =>{
                        if(e.key === 'Enter') {
                            e.preventDefault();
                            searchBarcode();
                        }
                    }}
                  
                   />
                  <button className="btn btn-outline-primary" type="button">Search</button>
                </div>
              </div>
            </div>
        </div>
    </AppLayout>
  )
}

export default BarcodeSearchPage